import { passkeyClient } from "@better-auth/passkey/client";
import { lastLoginMethodClient, magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  plugins: [magicLinkClient(), passkeyClient(), lastLoginMethodClient()],
});
